import React, { Component } from 'react';
import './outcome.css';
import { BackButton, ProTipButton } from '../buttons';

class Outcome extends Component {
    render() {
        return (
            <div className="hazard-outcome">
                <div className="container">
                    {this.props.infobit && (
                        <ProTipButton toggleTip={this.props.toggleTip} data={this.props.infobit} />
                    )}
                    <BackButton onClick={this.props.back} />
                    <h4>WHAT SHOE IS BEST FOR YOU?</h4>
                    <h3 className="outcome">{this.props.label}</h3>
                    <img
                        className="outcome-image"
                        width="510"
                        height="510"
                        src={this.props.photo}
                        alt={this.props.label}
                    />
                    <div className="outcome-actions">
                        {this.props.links.map((obj, i) => {
                            return <LinkButton key={i} {...obj} />;
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

class LinkButton extends Component {
    render() {
        return (
            <a className="learn-more" target="_blank" href={this.props.link}>
                <div className="learn-more-flex">
                    <span>{this.props.label}</span>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 35 35"
                        width="35"
                        height="35"
                    >
                        <g fill="#fff">
                            <path d="M17.5,35C27.1,35,35,27.1,35,17.5S27.1,0,17.5,0S0,7.9,0,17.5S7.9,35,17.5,35z M17.5,2.2 c8.4,0,15.3,6.9,15.3,15.3s-6.9,15.3-15.3,15.3S2.2,25.9,2.2,17.5S9.1,2.2,17.5,2.2z" />
                            <path d="M9.7,18.6h12.4l-4.3,3.5c-0.4,0.4-0.5,1.1-0.1,1.5s1.1,0.5,1.5,0.1l6.7-5.5 c0.2-0.1,0.3-0.4,0.3-0.8s-0.1-0.7-0.4-0.9l-6.7-5.5c-0.2-0.2-0.4-0.2-0.7-0.2c-0.3,0-0.7,0.1-0.9,0.4c-0.4,0.4-0.3,1.2,0.1,1.5 l4.4,3.5H9.7c-0.7,0-1.1,0.4-1.1,1.1S9.2,18.6,9.7,18.6L9.7,18.6z" />
                        </g>
                    </svg>
                </div>
            </a>
        );
    }
}

export default Outcome;



// WEBPACK FOOTER //
// ./src/components/outcome/outcome.js